import script from "./BetBuilderPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BetBuilderPanel.vue?vue&type=script&setup=true&lang=ts"

import "./BetBuilderPanel.vue?vue&type=style&index=0&id=04a9e0df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a9e0df"]])

export default __exports__